import { px, py } from '@/layout/styles/classes';
import styled from '@emotion/styled';
import { StaticImage } from 'gatsby-plugin-image';

const Section = styled.section`
    ${py};
    ${px};

    > p {
        margin: 0 0 4px;
        text-align: center;
    }

    > h2 {
        max-width: max-content;
        margin: 0 auto;
    }

    > iframe {
        display: block;
        margin: 24px auto 0;
        max-width: 100%;
        overflow: hidden;
        opacity: 0.9999; //safari overflow bug fix
        border-radius: 16px;
        box-shadow: 12px 12px 0px 0px ${({ theme }) => theme.colors.blue4};
        height: 52vw;
        max-height: 481px;
        border: none;

        @supports (aspect-ratio: 1/1) {
            height: auto;
            aspect-ratio: 16 / 9;
        }
    }

    @media (min-width: 1280px) {
        > iframe {
            margin-top: 48px;
            box-shadow: 24px 24px 0px 0px ${({ theme }) => theme.colors.blue4};
        }
    }
`;

export const Featured = () => {
    return (
        <Section>
            <p className="tagline">featured</p>
            <h2>
                <StaticImage
                    src="../../../assets/images/home/featured.png"
                    alt="worldwide business with Kathy Ireland"
                    width={697}
                    height={130}
                />
            </h2>

            <iframe
                width={855}
                height={481}
                src="https://www.youtube.com/embed/5Gg485Q-Qng"
                title="Smart AZ Minerals featured on Worldwide Business with Kathy Ireland"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
            />
        </Section>
    );
};
